import {
  CreatePageInvitationRequest,
  PreviewPageInvitationRequest,
} from "@shared/dtos/requests/pageInvitationRequests.dto"
import {
  PageInvitationEmailPreviewResponse,
  PageInvitationResponse,
} from "@shared/dtos/responses/pageInvitationResponses.dto"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

/**
 * Mint a one-time `PageInvitation` link bound to `req.recipientEmail`. The
 * backend also dispatches the invitation email (best-effort: a failed send is
 * reported in `response.emailDelivery` but does not roll the row back).
 */
export const create = async (
  practiceId: string,
  pageId: string,
  req: CreatePageInvitationRequest
): Promise<PageInvitationResponse> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/pages/${pageId}/invitations`,
    method: "post",
    data: req,
  })
  return resp.data
}

/**
 * Render the invitation email the backend would send for the given draft,
 * without persisting an invitation. Used by the portal modal to show staff
 * an inline preview of the templated email body. Returns `null` when the
 * practice has disabled the underlying template.
 */
export const previewEmail = async (
  practiceId: string,
  pageId: string,
  req: PreviewPageInvitationRequest
): Promise<PageInvitationEmailPreviewResponse | null> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/pages/${pageId}/invitations/preview`,
    method: "post",
    data: req,
  })
  return resp.data
}
